import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, Typography } from "@mui/material";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px"
};

interface Props {
  onCancel: () => void;
  title: string;
  type: "aiExtraction" | "aiCategorization" | "lookThrough";
  applyButtonText?: string;
  cb?: () => Promise<void>;
}

export const AiProcessingContent: React.FC<Props> = ({ onCancel, title, type, applyButtonText, cb }) => {
  const messages = {
    aiExtraction: "This file is already classified. AI will extract the data but will not change its classification.",
    aiCategorization:
      "This feature is optimized for private equity fund PDF documents\n(e.g., capital account statements and cash flow notices).\n\nWhen you apply, this file will be processed by AI. Processing may take a few moments.\nYou'll be notified in the app when it's complete, and the file will be moved to your Altus Classification folder.",
    lookThrough:
      "Please wait while the AI extracts the look-through data. You’ll be redirected to the Look-Through page when the process completes."
  };

  const onSubmit = () => {
    if (cb) {
      cb();
    }
    onCancel();
  };

  return (
    <Stack
      sx={{
        ...style,
        display: "flex",
        flexDirection: "column",
        width: 525,
        p: "32px",
        borderRadius: "8px",
        bgcolor: "white",
        boxShadow:
          "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
      }}
    >
      <Stack gap="24px" justifyContent="space-between" sx={{ flexGrow: 1 }}>
        <Stack gap="15px">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ borderBottom: "1px solid #DAE0E2" }}
          >
            <Typography>{title}</Typography>
            <IconButton onClick={onCancel}>
              <CloseIcon className="icon" />
            </IconButton>
          </Stack>

          <Stack gap="15px" sx={{ flexGrow: 1 }} justifyContent="space-between">
            <Typography sx={{ whiteSpace: "pre-line" }}>{messages[type]}</Typography>
          </Stack>
        </Stack>

        <Stack direction="row" gap="10px" justifyContent="flex-end" alignItems="center">
          <Stack gap="10px" direction="row" alignItems="center">
            <Button onClick={onCancel} variant="outlined">
              Cancel
            </Button>
            <Button onClick={onSubmit} variant="contained">
              {applyButtonText || "OK"}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
